import { CardHeader, CardTitle } from "@/components/ui/card";

export function ChartTitle() {
  return (
    <CardHeader className="pb-2">
      <CardTitle className="text-lg font-heading font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
        Atividades Mensais
      </CardTitle>
    </CardHeader>
  );
}